import React, { useState } from 'react';
import classNames from 'classnames/bind';

// Components
import { Text, Button } from '@beef/ui-kit';
import { Picture } from 'components';

// Styles
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const ErrorBlock = ({ text }) => {
  const [isLoading, setLoading] = useState(false);

  const refresh = () => {
    setLoading(true);
    document.location.reload();
  };

  return (
    <div className={cx('page-error')}>
      <Picture
        className={cx('page-error__img')}
        defaultImage="https://static.beeline.ru/upload/images/b2c/sfp-statuses-icons/error.svg"
      />
      <div className={cx('page-error__text')}>
        <Text>
          {' '}
          {text || 'Что-то пошло не так, перезагрузите страницу'}
        </Text>
      </div>
      <Button
        onClick={refresh}
        disabled={isLoading}
        variant="tertiary"
      >
        Перезагрузить страницу
      </Button>
    </div>
  );
};

export default ErrorBlock;
